module.exports = __webpack_public_path__ + "static/sol-k12-section-4-img-aae22413bb55aeb8a978e66182ec4f97.png";